import React, { useState } from 'react';
import { Button, Checkbox, Form, ConfigProvider } from 'antd';
import { FormOutlined } from '@ant-design/icons';

interface ScheduleNotaryCamFormProps {
    changesRequested?: {
      [key: string]: boolean;
    };
    onSave: (data: { id: string; messages: { id: string; embedding: string }[] }) => Promise<void>;
    caseId: string;
    completed: boolean;
    checked: boolean;
    messageId: string;
  }

export const ScheduleNotaryCamForm: React.FC<ScheduleNotaryCamFormProps> = (props) => {
    const [componentDisabled, setComponentDisabled] = useState<boolean>(false);

    const handleScheduleSession = () => {
        const scheduleSessionUrl = import.meta.env.VITE_NOTARY_CAM_URL;
        window.open(scheduleSessionUrl, '_blank');
      };

      const handleNotaryCamCompleted = () => {
        const input = {
          id: props.caseId,
          messages: [
            {
              id: props.messageId,
              embedding: JSON.stringify([
                {
                  value: 'documentRequestType',
                  completed: true,
                  checked: props.checked,
                  revisionRequest: {
                    requestedChanges: {
                      ...props.changesRequested
                    }
                  }
                }
              ])
            }
          ],
          revisionRequest: {
            requestedChanges: {
              requestScheduleNotaryCam: false
            },
            revisionSubmittedAt: new Date().toISOString()
          }
        };
        props.onSave(input);
      };
      
    return (
      <ConfigProvider
        theme={{
          components: {
            Form: {
              itemMarginBottom: 0
            }
          }
        }}
      >
        {!props.completed ? (
          <Form className='overflow-auto shadow-sm'>
           <p> <b> Step 1: Schedule Session</b></p> 
            <Button onClick={handleScheduleSession} className='bg-[#DBFFC5] mb-8 rounded-lg w-auto' >
              <FormOutlined /> Schedule Session
            </Button>
            <br />
            <b> Step 2: When Session is Complete:</b>
            <br />
            <Form.Item className='mx-5 my-0' name={['caseDetails', 'application', 'isAttestationComplete']} valuePropName="checked">
              <Checkbox checked={componentDisabled || props.checked} onChange={(e) => setComponentDisabled(e.target.checked)}>
              I have completed my identity verification session.
              </Checkbox>
            </Form.Item>
            <Form.Item>
              <Button onClick={handleNotaryCamCompleted} className=' rounded-lg float-right w-auto' type="primary" disabled={!componentDisabled}>
                Complete Activity
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <div className='m-1 p-1 pb-4'>
            <p>Schedule NotaryCam Appointment Completed</p>
            <Button onClick={handleNotaryCamCompleted} className='rounded-lg float-right w-auto' type="primary" disabled={true}>
              Schedule
            </Button>
          </div>
        )}
      </ConfigProvider>
    );
  };
